/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */

import React, { useRef, useCallback } from 'react';

import Select from 'react-select';
import { Disabled, FormTokenField , Icon, Button, Dropdown, RadioControl, Draggable, Panel, TextControl, TextareaControl, TabPanel, ToggleControl, PanelBody, PanelRow, CheckboxControl, SelectControl, ColorPicker, Provider, PopoverSlot, DropZone } from '@wordpress/components';
import { InspectorControls, useBlockProps, RichTextToolbarButton, RichText, AlignmentToolbar, BlockControls, SVG, Path  } from '@wordpress/block-editor';
import { useState, useEffect} from '@wordpress/element';

import CodeMirror from '@uiw/react-codemirror';
import { css } from '@codemirror/lang-css';
import { javascript, esLint } from "@codemirror/lang-javascript";
import { basicSetup } from "codemirror";

import apiFetch from '@wordpress/api-fetch';

import { v4 as uuidv4 } from 'uuid';
import Parser from 'html-react-parser';

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';


/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

export default function Edit(props) {
	const { attributes, setAttributes } = props;
	const AddRule = {
		id: uuidv4(),
		index: JSON.parse(attributes.rule_and_condition),
		data_filter: [
			{
				sub_id: uuidv4(),
				display_rule_types: "",
				values: "",
				operators: "",
				child_rule_type: 0,
			},
		],
		rule_type: "0",
	};
	const AddRule2 = {
		id: uuidv4(),
		index: JSON.parse(attributes.rule_and_condition2),
		data_filter: [
			{
				sub_id: uuidv4(),
				display_rule_types: "",
				values: "",
				operators: "",
				child_rule_type: 0,
			},
		],
		rule_type: "0",
	};
	const value =
		JSON.parse(attributes.rule_and_condition) === 0
			? [AddRule]
			: JSON.parse(attributes.rule_and_condition);
	const value2 =
		JSON.parse(attributes.rule_and_condition2) === 0
			? [AddRule2]
			: JSON.parse(attributes.rule_and_condition2);
	const [rule_and_condition, setRulesCondition] = useState(value);
	const [rule_and_condition2, setRulesCondition2] = useState(value2);
	const [product, setAddproduct] = useState([]);
	const [selectTab, setSelectTab] = useState("general-tab");
	const onSelect = (tabName) => {
		setSelectTab(tabName);
	};

	return (
		<div
			{...useBlockProps({
				className: "gb_block_main_wrapp",
			})}
		>
			<InspectorControls key="dynamic-product-block-settings">
				<React.Fragment>
					<TabPanel
						className="gb_dynamic_product_block_sett_wrapp"
						activeClass="active-tab"
						onSelect={onSelect}
						tabs={[
							{
								name: "general-tab",
								title: "General",
								className: "general-tab db-settings-tab",
							},
							{
								name: "style-tab",
								title: "Style",
								className: "style-tab db-settings-tab",
							},
							{
								name: "advanced-tab",
								title: "Advanced",
								className: "advanced-tab db-settings-tab",
							},
						]}
					>
						{(tab) => (
							<>
								{selectTab === "general-tab" ? (
									<GeneralComponent
										props={props}
										rule_and_condition={rule_and_condition}
										rule_and_condition2={rule_and_condition2}
										setAttributes={setAttributes}
										setRulesCondition={setRulesCondition}
										setRulesCondition2={setRulesCondition2}
										product={product}
										setAddproduct={setAddproduct}
									></GeneralComponent>
								) : selectTab === "style-tab" ? (
									<StyleComponent
										props={props}
										setAttributes={setAttributes}
									></StyleComponent>
								) : (
									<AdvancedComponent
										props={props}
										setAttributes={setAttributes}
									></AdvancedComponent>
								)}
							</>
						)}
					</TabPanel>
				</React.Fragment>
			</InspectorControls>
			<p>
				<ProductPreviewLoop props={props.attributes} />
			</p>
		</div>
	);
}


const ProductPreviewLoop = (props) => {
	const [product, addAddproduct] = useState([]);

	const [error, setError] = useState(null);
	const [appProducts, setPost] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);

	const [qdata, setqdata] = useState([null]);

	useEffect(() => {
		while (qdata?.length) {
			qdata.pop();
		}

		for (const [key, value] of Object.entries(props.props)) {
			let values = {
				label: key,
				value: value,
			};
			qdata.push(values);
			setqdata(qdata);
		}
		apiFetch({
			path: "/dynamicblock/v1/product-filter",
			method: "POST",
			data: props.props,
		}).then(
			(result) => {
				setIsLoaded(true);
				setPost(result);
			},
			(error) => {
				setIsLoaded(true);
				setError(error);
			}
		);
	}, [props.props]);
	const newdata = {
		margin: 0,
		autoplay: props.props.autoplayToggle ? true : false,
		autoplayTimeout: 2000,
		nav: true,
		navText: ['<i class="dashicons dashicons-arrow-left-alt2"></i>', '<i class="dashicons dashicons-arrow-right-alt2"></i>'],
	};
	if (error) {
		return <p>ERROR: {error.message}</p>;
	} else if (!isLoaded) {
		return <p>Loading..</p>;
	} 
	else if (appProducts.length == 0) {
		return (
			<div className="db-block-preview-container">
				<div className="db-preview-main-product-wrap">
					<span>{__("Hi, to preview the products, you must first select the logical conditions in the what to display tab. Thank you")}</span>
				</div>
			</div>
		);
	} else {
		return (
			<>
				<div className="db-block-preview-container">
					<h2>{props.props.block_title}</h2>
					<div className="db-preview-main-product-wrap">
						{props.props.carouselToggle != true ? (
							appProducts.map((obj, i) => {
								return (
									<div className="db-preview-single-product-data" key={obj.id}>
										<div className="db-preview-single-product-data-box">
											<div className="db-preview-single-product-data-title">
												<h2>{obj.post_title}</h2>
											</div>
											<div className="db-preview-single-product-data-image">
												<img src={obj.feature_image} />
											</div>
											<div className="single-product-data-content" id={i}>
												{props.props.excerptToggle === true ? (
													<p>
														{obj.post_excerpt.substring(0, 60)}
														{obj.post_excerpt.length > 60 ? "..." : ""}
													</p>
												) : (
													""
												)}

												<span class="db-preview-price-wrap">
													{Parser(JSON.parse(obj.price_html))}
												</span>
												{props.props.addToCartBtnToggle === true ? (
													<a
														href="#"
														class="button wp-element-button product_type_simple add_to_cart_button ajax_add_to_cart"
													>
														Add to Cart
													</a>
												) : (
													""
												)}
											</div>
										</div>
									</div>
								);
							})
						) : (
							<OwlCarousel className="owl-theme" {...newdata}>
								{appProducts?.map((obj, i) => {
									if (i + 1 <= props?.props?.limit) {
										
										return (
											<div
												className="db-preview-single-product-data"
												key={obj.id}
											>
												<div className="db-preview-single-product-data-box">
													<div className="db-preview-single-product-data-title">
														<h2>{obj.post_title}</h2>
													</div>
													<div className="db-preview-single-product-data-image">
														<img src={obj.feature_image} />
													</div>
													<div className="single-product-data-content" id={i}>
														{props.props.excerptToggle === true ? (
															<p>
																{obj.post_excerpt.substring(0, 60)}
																{obj.post_excerpt.length > 60 ? "..." : ""}
															</p>
														) : (
															""
														)}

														<span class="db-preview-price-wrap">
															{Parser(JSON.parse(obj.price_html))}
														</span>
														{props.props.addToCartBtnToggle === true ? (
															<a
																href="#"
																class="button wp-element-button product_type_simple add_to_cart_button ajax_add_to_cart"
															>
																Add to Cart
															</a>
														) : (
															""
														)}
													</div>
												</div>
											</div>
										);
									} 
									else if (props?.props?.limit?.length === 0) {
										
										return (
											<div
												className="db-preview-single-product-data"
												key={obj.id}
											>
												<div className="db-preview-single-product-data-box">
													<div className="db-preview-single-product-data-title">
														<h2>{obj.post_title}</h2>
													</div>
													<div className="db-preview-single-product-data-image">
														<img src={obj.feature_image} />
													</div>
													<div className="single-product-data-content" id={i}>
														{props.props.excerptToggle === true ? (
															<p>
																{obj.post_excerpt.substring(0, 60)}
																{obj.post_excerpt.length > 60 ? "..." : ""}
															</p>
														) : (
															""
														)}

														<span class="db-preview-price-wrap">
															{Parser(JSON.parse(obj.price_html))}
														</span>
														{props.props.addToCartBtnToggle === true ? (
															<a
																href="#"
																class="button wp-element-button product_type_simple add_to_cart_button ajax_add_to_cart"
															>
																Add to Cart
															</a>
														) : (
															""
														)}
													</div>
												</div>
											</div>
										);
									}
								})}
							</OwlCarousel>
						)}
					</div>
				</div>
			</>
		);
	}
};

const GeneralComponent = (props) => {
	const { attributes, setAttributes } = props;
	const getAttr = props.props.attributes;

	// what to display
	const rule_and_condition = props?.rule_and_condition;
	const setRulesCondition = props?.setRulesCondition;
	const [dragstatus, setDragstatus] = useState(false);
	const [statusdrag, setStatusdrag] = useState(false);
	const [RulesTypes] = useState([]);
	const [removeform, setRemoveform] = useState(false);
	const [defaultreset, setdefaultreset] = useState(false);
	const [options] = useState([]);
	const dragItem = useRef();
	const dragOverItem = useRef();

	// When to display
	const rule_and_condition2 = props?.rule_and_condition2;
	const setRulesCondition2 = props?.setRulesCondition2;
	const [dragstatus2, setDragstatus2] = useState(false);
	const [statusdrag2, setStatusdrag2] = useState(false);
	const [RulesTypes2] = useState([]);
	const [removeform2, setRemoveform2] = useState(false);
	const [defaultreset2, setdefaultreset2] = useState(false);
	const [options2] = useState([]);
	const dragItem2 = useRef();
	const dragOverItem2 = useRef();

	useEffect(() => {
		getAlldata();
	}, []);

	// what to display dataset remove cross sign
	useEffect(() => {
		removeCrosssign();
	}, [props?.props?.attributes?.dataset]);

	const removeCrosssign = () => {
		const isClearables = document.getElementById("db_panel_dataset");
		const child = document.getElementsByClassName(
			"css-12a83d4-MultiValueRemove"
		);
		const remove = child[0]?.setAttribute("id", "css-12a83d4-MultiValueRemove");
		if (
			props?.props?.attributes?.dataset?.length === 1 &&
			isClearables &&
			child
		) {
			const Removecross = document.getElementById(
				"css-12a83d4-MultiValueRemove"
			);
			if (Removecross) {
				document.getElementById("css-12a83d4-MultiValueRemove").style.display =
					"none";
			}
		} else {
			if (child[0] !== undefined) {
				document.getElementById("css-12a83d4-MultiValueRemove").style.display =
					"";
			}
		}
	};

	// what to display dataset2 remove cross sign
	useEffect(() => {
		removeCrosssign2();
	}, [props?.props?.attributes?.dataset2]);

	const removeCrosssign2 = () => {
		const isClearables2 = document.getElementById("db_panel_dataset2");
		const child2 = document.getElementsByClassName(
			"css-12a83d4-MultiValueRemove"
		);
		const remove = child2[0]?.setAttribute(
			"id",
			"css-12a83d4-MultiValueRemove2"
		);
		if (
			props?.props?.attributes?.dataset2?.length === 1 &&
			isClearables2 &&
			child2
		) {
			const Removecross = document.getElementById(
				"css-12a83d4-MultiValueRemove2"
			);
			if (Removecross) {
				document.getElementById("css-12a83d4-MultiValueRemove2").style.display =
					"none";
			}
		} else {
			if (child2[0] !== undefined) {
				document.getElementById("css-12a83d4-MultiValueRemove2").style.display =
					"";
			}
		}
	};

	// const dragelement = (e, position, status, module_number) => {
	// 	if (module_number === 0) {
	// 		setStatusdrag(status);
	// 		return dragStart(e, position, module_number);
	// 	} else {
	// 		setStatusdrag2(status);
	// 		return dragStart(e, position, module_number);
	// 	}
	// };


	const dragelement = useCallback((e, position, module_number) => {
		if (module_number === 0) {
			setStatusdrag(true);
			dragStart(e, position, module_number);
			document.addEventListener(
				"mouseup",
				() => {
					setStatusdrag(false);
				},
				{ once: true }
			);
		} else {
			setStatusdrag2(true);
			dragStart(e, position, module_number);
			document.addEventListener(
				"mouseup",
				() => {
					setStatusdrag2(false);
				},
				{ once: true }
			);
		}
		document.addEventListener(
			"mouseup",
			() => {
				
			},
			{ once: true }
		);
	}, []);

	
	const dragStart = (e, position, module_number) => {
		if (module_number === 0) {
			return (dragItem.current = position);
		} else {
			return (dragItem2.current = position);
		}
	};

	const dragOver = (module_number) => {
		
		if (module_number === 0 && statusdrag === true) {
			// return setStatusdrag(false);
		} else if (statusdrag2 === true) {
			return setStatusdrag2(false);
		}
	};


	const dragEnter = (e, position, module_number) => {
		if (module_number === 0) {
			return (dragOverItem.current = position);
		} else {
			return (dragOverItem2.current = position);
		}
	};
	const drop = (e) => {
		// when to display
		const copyListItems2 = [...rule_and_condition2];
		const dragItemContent2 = copyListItems2[dragItem2.current];
		copyListItems2.splice(dragItem2.current, 1);
		copyListItems2.splice(dragOverItem2.current, 0, dragItemContent2);
		dragItem2.current = null;
		dragOverItem2.current = null;
		let newlist = copyListItems2?.map((list, index) => {
			list.index = index;
			return list;
		});
		setRulesCondition2(newlist);
		if (newlist?.length) {
			setStatusdrag2(false);
			setDragstatus2(true);
			return props.setAttributes({
				rule_and_condition2: JSON.stringify(newlist),
			});
		}
	};

	const drop1 = (e) => {
		// what to display
		const copyListItems = [...rule_and_condition];
		const dragItemContent = copyListItems[dragItem.current];
		copyListItems.splice(dragItem.current, 1);
		copyListItems.splice(dragOverItem.current, 0, dragItemContent);
		dragItem.current = null;
		dragOverItem.current = null;
		let newlist = copyListItems?.map((list, index) => {
			list.index = index;
			return list;
		});
		setRulesCondition(newlist);
		if (newlist?.length) {
			setStatusdrag(false);
			setDragstatus(true);
			return props.setAttributes({
				rule_and_condition: JSON.stringify(newlist),
			});
		}
	};
	const getAlldata = () => {
		// What to display
		apiFetch({ path: "/dynamicblock/v1/all_display_rule_types" }).then(
			(posts) => {
				for (const [key, value] of Object.entries(posts)) {
					let rules = {
						label: key,
						value: key,
					};
					options.push(rules);

					const status = getAttr?.dataset?.length === 0 ? true : false;
					const status1 = getAttr?.dataset === undefined ? true : false;
					if (options?.length && (status || status1)) {
						setAttributes({ dataset: [options[0]] });
					}

					for (const [key, value] of Object.entries(posts[rules?.value])) {
						let values = {
							label: value[key],
							value: key,
							optionType: rules.value,
							disabled: key === "pro_version" ? true : false,
							alloption: value?.rule_types,
						};
						RulesTypes.push(values);
					}
				}
			}
		);

		// When to display
		apiFetch({ path: "/dynamicblock/v1/all_when_to_display_rule" }).then(
			(posts) => {
				for (const [key, value] of Object.entries(posts)) {
					let rules = {
						label: key,
						value: key,
					};
					options2.push(rules);

					const status = getAttr?.dataset2?.length === 0 ? true : false;
					const status1 = getAttr?.dataset2 === undefined ? true : false;
					if (options2?.length && (status || status1)) {
						setAttributes({ dataset2: [options2[0]] });
					}

					for (const [key, value] of Object.entries(posts[rules?.value])) {
						let values = {
							label: value[key],
							value: key,
							optionType: rules.value,
							disabled: key === "pro_version" ? true : false,
							alloption: value?.rule_types,
						};
						RulesTypes2.push(values);
					}
				}
			}
		);
	};

	const AddedProduct = (module_number) => {
		if (module_number === 0) {
			const AddRules = {
				id: uuidv4(),
				index: rule_and_condition?.length,
				data_filter: [
					{
						sub_id: uuidv4(),
						display_rule_types: "",
						values: "",
						operators: "",
						child_rule_type: 0,
					},
				],
				rule_type: "0",
			};

			rule_and_condition.push(AddRules);
			setRulesCondition(rule_and_condition);
			if (rule_and_condition.length) {
				props.setAttributes({
					rule_and_condition: JSON.stringify(rule_and_condition),
				});
			}
		} else {
			const AddRules2 = {
				id: uuidv4(),
				index: rule_and_condition2?.length,
				data_filter: [
					{
						sub_id: uuidv4(),
						display_rule_types: "",
						values: "",
						operators: "",
						child_rule_type: 0,
					},
				],
				rule_type: "0",
			};

			rule_and_condition2.push(AddRules2);
			setRulesCondition2(rule_and_condition2);
			if (rule_and_condition2.length) {
				props.setAttributes({
					rule_and_condition2: JSON.stringify(rule_and_condition2),
				});
			}
		}
	};

	const removeProduct = (list, module_number) => {
		if (module_number === 0) {
			const removedata = rule_and_condition?.filter(
				(listid) => listid.id !== list.id
			);
			setRulesCondition(removedata);
			setRemoveform(true);
			props.setAttributes({ rule_and_condition: JSON.stringify(removedata) });
		} else {
			const removedata2 = rule_and_condition2?.filter(
				(listid) => listid.id !== list.id
			);
			setRulesCondition2(removedata2);
			setRemoveform2(true);
			props.setAttributes({ rule_and_condition2: JSON.stringify(removedata2) });
		}
	};

	const setoptions = (status, list, module_number) => {
		if (module_number === 0) {
			const setoptiondata = rule_and_condition.map((listid) => {
				if (listid.id === list.id) {
					listid.rule_type = status;
					return listid;
				} else {
					return listid;
				}
			});
			setRulesCondition(setoptiondata);
			props.setAttributes({
				rule_and_condition: JSON.stringify(rule_and_condition),
			});
		} else {
			const setoptiondata = rule_and_condition2.map((listid) => {
				if (listid.id === list.id) {
					listid.rule_type = status;
					return listid;
				} else {
					return listid;
				}
			});
			setRulesCondition2(setoptiondata);
			props.setAttributes({
				rule_and_condition2: JSON.stringify(rule_and_condition2),
			});
		}
	};

	return (
		<>
			<PanelBody
				className="bg_general_tab_content bg_block_tab_content_wrap"
				title="Block Info"
				initialOpen={true}
			>
				<PanelRow>
					<div className="block-info-container">
						<p>{__("Choose a Block Title or leave blank.")}</p>
					</div>
				</PanelRow>
				<PanelRow>
					<TextControl
						label={__("Title")}
						placeholder={__("example name")}
						help={__("insert block title")}
						value={getAttr.block_title}
						onChange={(val) => setAttributes({ block_title: val })}
					/>
				</PanelRow>
				<PanelRow>
					<div>
						<TextareaControl
							label={__("Note")}
							type="textarea"
							placeholder={__("example desc")}
							value={getAttr.block_note}
							onChange={(val) => setAttributes({ block_note: val })}
							help={__(
								"write some notes on the block to remember what it is for"
							)}
						/>
					</div>
				</PanelRow>
			</PanelBody>
			<PanelBody title={__("What to display")} initialOpen={false}>
				<PanelRow>
					<div class="db_panel_whtd_note">
						<p className="">
							{__(
								"Choose the products you would like to show based on customizable criteria."
							)}
						</p>
					</div>
				</PanelRow>
				<PanelRow>
					<div class="db_panel_dataset_and_ordering">
						<div id="db_panel_dataset" class="db_panel_dataset">
							<label>{__("Datasets")}</label>
							<Select
								value={getAttr?.dataset}
								options={options}
								isMulti={true}
								// closeMenuOnSelect={true}
								onChange={(tokens) => {
									if (tokens.length > 0) {
										setdefaultreset(true);
										setAttributes({ dataset: tokens });
									}
								}}
							/>
						</div>

						<div class="db_panel_dataset_order_limit">
							<SelectControl
								label="Order By"
								value={getAttr.order_by}
								options={[
									{ label: "Date", value: "date" },
									{ label: "Name", value: "title" },
									{ label: "Random", value: "rand" },
								]}
								onChange={(opt) => setAttributes({ order_by: opt })}
							/>
							<SelectControl
								label="Mode"
								value={getAttr.mode}
								options={[
									{ label: "ASC", value: "acs" },
									{ label: "DESC", value: "desc" },
								]}
								onChange={(tokens) => setAttributes({ mode: tokens })}
							/>
							<TextControl	
								label={__("Limit")}
								placeholder={__("5")}
								value={getAttr.limit}
								onChange={(value) => {
									const val=value.replace(/\D/g, '')
									// setAttributes({ limit: '0' }
									if (val>0) {
										return setAttributes({ limit: val });
									} else {
										return setAttributes({ limit: "" });
									}
								}}
							/>
						</div>
					</div>
				</PanelRow>
				<PanelRow>
					<div>
						<div class="db_panel_rc">
							<h3>{__("Rules & Conditions")}</h3>
							<p className="">
								{__(
									"Create your own set of rules to choose which products to show."
								)}
							</p>
						</div>
						{rule_and_condition?.length && rule_and_condition?.length >= 1
							? rule_and_condition?.map((list, index) => {
									return (
										<>
											<div
												className={
													statusdrag === true
														? "gb-product-rules-wrap draggable_active"
														: "gb-product-rules-wrap"
												}
												onDragStart={(e) => dragStart(e, index, 0)}
												onDragEnter={(e) => dragEnter(e, index, 0)}
												onDragEnd={drop1}
												key={index}
												draggable={statusdrag}
											>
												<div className="bg_panel_single_rule">
													<RadioControl
														draggable={false}
														selected={list?.rule_type}
														className="radio-option111"
														options={[
															{ label: "AND", value: "0" },
															{ label: "OR", value: "1" },
														]}
														onChange={(value) => setoptions(value, list, 0)}
													/>
													<div class="bg_panel_btns_wrapp">
														<button
															onMouseDown={(e) => dragelement(e, index, 0)}
															onMouseUp={(e) => dragelement(e, index, false, 0)}
															onMouseLeave={(e) => {
																dragOver(0);
																}}
															class="db_panel_btn_drag"
														>
															<span class="dashicons dashicons-editor-expand"></span>
														</button>
														<button
															class="db_panel_btn_add"
															onClick={() => AddedProduct(0)}
														>
															<span class="dashicons dashicons-plus"></span>
														</button>
														{rule_and_condition &&
														rule_and_condition.length > 1 ? (
															<button
																class="db_panel_btn_remove"
																onClick={() => removeProduct(list, 0)}
															>
																<span class="dashicons dashicons-minus"></span>
															</button>
														) : (
															""
														)}
													</div>
												</div>
												<div className="menu-block">
													{list?.data_filter?.map((subdata, i) => {
														return (
															<ProductSubCategory
																setAttributes={setAttributes}
																rule_and_condition={rule_and_condition}
																list={list}
																subdata={subdata}
																RulesTypes={RulesTypes}
																setRulesCondition={setRulesCondition}
																removeform={removeform}
																defaultreset={defaultreset}
																setdefaultreset={setdefaultreset}
																setRemoveform={setRemoveform}
																attributes={props.props?.attributes}
																dragstatus={dragstatus}
																setDragstatus={setDragstatus}
																removeCrosssign={removeCrosssign}
															/>
														);
													})}
												</div>
											</div>
										</>
									);
							  })
							: ""}
					</div>
				</PanelRow>
			</PanelBody>
			<PanelBody title={__("When to display")} initialOpen={false}>
				<PanelRow>
					<div class="db_panel_whtd_note">
						<p className="">
							{__(
								"When should the block be displayed ? Create your own dynamic rules."
							)}
						</p>
					</div>
				</PanelRow>
				<PanelRow>
					<div class="db_panel_dataset_and_ordering">
						<div id="db_panel_dataset2" class="db_panel_dataset">
							<label>{__("Datasets")}</label>
							<div class="db_panel_whtd_note">
								{/* <p className="">
									{__(
										"Datasets are groups of conditions that you can use to apply your own conditions to block. Click to select your datasets	"
									)}
								</p> */}
							</div>
							<Select
								value={getAttr?.dataset2}
								options={options2}
								isMulti={true}
								onChange={(tokens) => {
									if (tokens.length > 0) {
										setdefaultreset2(true);
										setAttributes({ dataset2: tokens });
									}
								}}
							/>
						</div>
					</div>
				</PanelRow>
				<PanelRow>
					<div>
						<div class="db_panel_rc">
							<h3>{__("Rules & Conditions")}</h3>
							<p className="">
								{__("Create your own set of rules to choose which products to show.")}
							</p>
						</div>
						{rule_and_condition2?.length && rule_and_condition2?.length >= 1
							? rule_and_condition2?.map((list, index) => {
									return (
										<>
											<div
												className={
													statusdrag2 === true
														? "gb-product-rules-wrap draggable_active"
														: "gb-product-rules-wrap"
												}
												onDragStart={(e) => dragStart(e, index, 1)}
												onDragEnter={(e) => dragEnter(e, index, 1)}
												onDragEnd={drop}
												key={index}
												draggable={statusdrag2}
											>
												<div className="bg_panel_single_rule">
													<RadioControl
														draggable={false}
														selected={list?.rule_type}
														className="radio-option111"
														options={[
															{ label: "AND", value: "0" },
															{ label: "OR", value: "1" },
														]}
														onChange={(value) => setoptions(value, list, 1)}
													/>
													<div class="bg_panel_btns_wrapp">
														<button
															onMouseDown={(e) => dragelement(e, index, 1)}
															onMouseUp={(e) => dragelement(e, index, false, 1)}
															onMouseLeave={(e) => {
																dragOver(1);
																}}
															class="db_panel_btn_drag"
														>
															<span class="dashicons dashicons-editor-expand"></span>
														</button>
														<button
															class="db_panel_btn_add"
															onClick={() => AddedProduct(1)}
														>
															<span class="dashicons dashicons-plus"></span>
														</button>
														{rule_and_condition2 &&
														rule_and_condition2.length > 1 ? (
															<button
																class="db_panel_btn_remove"
																onClick={() => removeProduct(list, 1)}
															>
																<span class="dashicons dashicons-minus"></span>
															</button>
														) : (
															""
														)}
													</div>
												</div>
												<div className="menu-block">
													{list?.data_filter?.map((subdata, i) => {
														return (
															<ProductSubCategory2
																setAttributes={setAttributes}
																rule_and_condition2={rule_and_condition2}
																list={list}
																subdata={subdata}
																RulesTypes2={RulesTypes2}
																setRulesCondition2={setRulesCondition2}
																removeform2={removeform2}
																defaultreset2={defaultreset2}
																setdefaultreset2={setdefaultreset2}
																setRemoveform2={setRemoveform2}
																attributes={props.props?.attributes}
																dragstatus2={dragstatus2}
																setDragstatus2={setDragstatus2}
																removeCrosssign2={removeCrosssign2}
															/>
														);
													})}
												</div>
											</div>
										</>
									);
							  })
							: ""}
					</div>
				</PanelRow>
			</PanelBody>
			<PanelBody title={__("Where to Display")} initialOpen={false}>
				<PanelRow>
					<Disabled isDisabled>
						<TextControl label={__("Page")} placeholder={__("Custom Page")} />
						<TextControl
							label={__("Location")}
							placeholder={__("Current Page")}
						/>
					</Disabled>
				</PanelRow>
			</PanelBody>
		</>
	);
};

const ProductSubCategory2 = (props) => {
	const {
		rule_and_condition2,
		setAttributes,
		attributes,
		setRulesCondition2,
		list,
		RulesTypes2,
		removeform2,
		setRemoveform2,
		dragstatus2,
		defaultreset2,
		setdefaultreset2,
		setDragstatus2,
		removeCrosssign2,
		subdata,
	} = props;
	const [ProductOption, setProductOption] = useState([]);
	const [option, setoption] = useState();
	const [inputstatus, setinputstatus] = useState(Boolean);
	const [opreatorOption, setopreatorOption] = useState([]);
	const [condition_input_type, setCondition_input_type] = useState(true);
	const [inputType, setInputType] = useState("text");

	useEffect(() => {
		if (removeform2 || dragstatus2) {
			selectrules(subdata?.display_rule_types, false);
		}
	}, [rule_and_condition2]);

	useEffect(() => {
		if (subdata?.display_rule_types?.length > 0) {
			selectrules(subdata?.display_rule_types, false);
		} else {
			let defaultOption = RulesTypes2?.filter((option) => {
				return option?.optionType === attributes?.dataset2[0].value;
			});
			selectrules(defaultOption[0].value, false);
		}
		removeCrosssign2();
	}, [list?.data_filter.length]);

	useEffect(() => {
		if (subdata?.display_rule_types) {
			const optionTypess = RulesTypes2?.find((getopt) => {
				return getopt?.value === subdata?.display_rule_types;
			});
			if (optionTypess) {
				let resetOption = attributes?.dataset2?.filter((option) => {
					return option?.value === optionTypess?.optionType;
				});
				if (resetOption.length === 0) {
					subdata.values = "";
					subdata.operators = "";
					let defaultOption = RulesTypes2?.filter((option) => {
						return option?.optionType === attributes?.dataset[0]?.value;
					});
					if (defaultOption) {
						return selectrules(defaultOption[0].value, false);
					}
				}
			}
		}
	}, [attributes?.dataset2]);

	const getListCondition = async (display, status) => {
		await resetData(status);

		const pro_version = RulesTypes2?.filter((pro) => {
			return pro.value === display;
		});
		if (pro_version.length > 0) {
			getDetails(pro_version[0]?.value, status, "version");
		} else {
			getDetails(RulesTypes2[0]?.value, status, "pro_version");
		}
	};

	const getDetails = (display, status, versions) => {
		subdata.display_rule_types = display;
		const postss = RulesTypes2?.filter((data) => {
			if (data.value === display) {
				return data;
			}
		});

		if (postss[0]?.alloption) {
			if (postss[0]?.alloption?.condition_input_type) {
				if (
					postss[0]?.alloption?.condition_input_type === "Product_Select" ||
					postss[0]?.alloption?.condition_input_type === "Chosen_Select"
				) {
					setinputstatus(false);
					setCondition_input_type(true);
				} else if (
					postss[0]?.alloption?.condition_input_type === "Price_Select" ||
					postss[0]?.alloption?.condition_input_type === "Text" ||
					postss[0]?.alloption?.condition_input_type === "Store_Order_Count"
				) {
					setinputstatus(true);
				} else if (
					postss[0]?.alloption?.condition_input_type === "Order_Status" ||
					postss[0]?.alloption?.condition_input_type === "Select"
				) {
					setinputstatus(false);
					setCondition_input_type(false);
				} else if (postss[0]?.alloption?.condition_input_type === "Date") {
					setInputType("date");
					setinputstatus(true);
					setCondition_input_type(true);
				} else if (postss[0]?.alloption?.condition_input_type === "Number") {
					setInputType("number");
					setinputstatus(true);
					setCondition_input_type(true);
				} else if (
					postss[0]?.alloption?.condition_input_type === "Html_Always"
				) {
					setInputType("text");
					setinputstatus(true);
				}
			}
			if (
				opreatorOption.length === 0 &&
				postss[0]?.alloption?.operators !== null
			) {
				let operator = postss[0]?.alloption?.operators;
				for (const [key, value] of Object?.entries(operator)) {
					let rules = {};
					(rules.label = value),
						(rules.value = key),
						opreatorOption.push(rules);
					setopreatorOption(opreatorOption);
				}
			}

			//  values
			if (ProductOption.length === 0) {
				let values = postss[0]?.alloption?.values;
				if (postss[0]?.alloption?.condition_input_type === "Html_Always") {
					let rules = {};
					
					(rules.label = "Html_Always"),
					(rules.value = values),
					ProductOption.push(rules);
					
					setProductOption(ProductOption);
					subdata.values = JSON.stringify([ProductOption[0]]);
				} else {
					for (const [key, value] of Object?.entries(values)) {
						let rules = {};

						(rules.label = value),
							(rules.value = key),
							ProductOption.push(rules);
						setProductOption(ProductOption);
					}
				}
			}

			return applyconditions(status, versions);
		}
	};

	const AddedSubProduct = () => {
		const newSubRules = {
			sub_id: uuidv4(),
			display_rule_types: "",
			values: "",
			operators: "",
			child_rule_type: 0,
		};
		list?.data_filter?.push(newSubRules);
		setRulesCondition2(rule_and_condition2);
		setAttributes({
			rule_and_condition2: JSON.stringify(rule_and_condition2),
		});
	};

	const removeSubProduct = (subdata_id) => {
		const removeval = list?.data_filter?.filter((sub) => {
			if (sub?.sub_id !== subdata_id) {
				return sub;
			}
		});
		if (removeval[0]?.sub_id?.length > 0) {
			while (list?.data_filter?.length) {
				list?.data_filter.pop();
			}
			if (removeval[0]?.sub_id?.length > 0 && list?.data_filter.length === 0) {
				removeval.map((data_remain) => {
					list?.data_filter.push(data_remain);
					setRulesCondition2(rule_and_condition2);
					return setAttributes({
						rule_and_condition2: JSON.stringify(rule_and_condition2),
					});
				});
			}
		}
	};

	const applyconditions = (status, versions) => {
		if (defaultreset2) {
			setOperator(opreatorOption[0]?.value);
			subdata.values = "";
			setoption([]);
			setdefaultreset2(false);
			setRulesCondition2(rule_and_condition2);
			return setAttributes({
				rule_and_condition2: JSON.stringify(rule_and_condition2),
			});
		} else if (
			!defaultreset2 &&
			!dragstatus2 &&
			removeform2 &&
			subdata.values?.length &&
			subdata.operators?.length
		) {
			// when defaultreset2  is false and removeform2
			const selectremoveform =
				subdata.values?.length > 0 ? JSON.parse(subdata?.values) : [];
			setoption(selectremoveform);
			setRemoveform2(false);
		} else if (dragstatus2) {
			setoption([]);
			setDragstatus2(false);
			const val =
				subdata?.values.length === 0 ? "" : JSON.parse(subdata?.values);
			return setoption(val);
		} else if (status) {
			subdata.values = "";
			subdata.operators = opreatorOption[0]?.value;
			setOperator(opreatorOption[0]?.value);
		} else if (versions === "pro_version") {
			subdata.operators = "";
			subdata.values = "";
			setoption([]);
			setRulesCondition2(rule_and_condition2);
			return setAttributes({
				rule_and_condition2: JSON.stringify(rule_and_condition2),
			});
		} else {
			const selectedoption =
				subdata.values?.length > 0 ? JSON.parse(subdata?.values) : [];
			setoption(selectedoption);
		}
	};

	const resetData = async (status) => {
		if (status) {
			setoption([]);
		}
		while (opreatorOption?.length) {
			opreatorOption.pop();
		}

		while (ProductOption?.length) {
			ProductOption.pop();
		}
		setopreatorOption([]);
		setRulesCondition2(rule_and_condition2);
		setAttributes({ rule_and_condition2: JSON.stringify(rule_and_condition2) });
	};

	const selectrules = (option, status) => {
		setInputType("");
		setoption([]);
		subdata.display_rule_types = option;
		getListCondition(option, status);
		setAttributes({ rule_and_condition2: JSON.stringify(rule_and_condition2) });
	};

	const setOperator = (option) => {
		subdata.operators = option;
		setRulesCondition2(rule_and_condition2);
		setAttributes({ rule_and_condition2: JSON.stringify(rule_and_condition2) });
	};

	const setproducts = (option, type) => {
		subdata.operators =
			subdata.operators?.length > 0
				? subdata.operators
				: opreatorOption[0]?.value;
		if ("option" === type) {
			if (condition_input_type) {
				subdata.values = JSON.stringify(option);
			} else {
				subdata.values = JSON.stringify([option]);
			}
			setoption(option);
			setRulesCondition2(rule_and_condition2);
			setAttributes({
				rule_and_condition2: JSON.stringify(rule_and_condition2),
			});
		} else if (inputstatus) {
			const { type, value } = option.target;
			let objectval = {
				label: type,
				value: value,
			};
			subdata.values = JSON.stringify([objectval]);
			setoption(objectval);
			setRulesCondition2(rule_and_condition2);
			setAttributes({
				rule_and_condition2: JSON.stringify(rule_and_condition2),
			});
		}
	};
	return (
		<>
			<div id={subdata.id} className="selection-menu bg_panel_inputs_wrapp">
				<PanelRow>
					<select
						value={subdata?.display_rule_types}
						onChange={(e) => selectrules(e.target.value, true)}
					>
						{attributes?.dataset2?.map((optgrp) => {
							return (
								<>
									<optgroup label={optgrp?.label}>
										<option value="" disabled selected hidden>
											Please select {RulesTypes2[0]?.label}
										</option>
										{RulesTypes2?.map((opt_type) => {
											if (opt_type.optionType === optgrp?.label) {
												return (
													<option
														value={opt_type?.value}
														style={{ color: opt_type?.disabled ? "red" : "" }}
														disabled={opt_type?.disabled}
													>
														{opt_type?.label}
													</option>
												);
											}
										})}
									</optgroup>
								</>
							);
						})}
					</select>
				</PanelRow>
				<PanelRow>
					<SelectControl
						value={subdata?.operators?.length > 0 ? subdata.operators : ""}
						options={opreatorOption}
						placeholder={__("Select some users:")}
						onChange={(newval) => setOperator(newval)}
					/>
				</PanelRow>
				<PanelRow>
					{/* {JSON.stringify(option[0])} */}
					{!inputstatus ? (
						<Select
							value={JSON.stringify(option)?.length > 2 ? option : []}
							options={ProductOption}
							isMulti={condition_input_type}
							onChange={(e) => setproducts(e, "option")}
						/>
					) : (
						<input
							value={JSON.stringify(option)?.length > 2 ? option[0]?.value : ProductOption[0]?.label === 'Html_Always' ? ProductOption[0]?.value : '' }
							type={inputType}
							onChange={(e) => setproducts(e, "input")}
							disabled={ProductOption[0]?.label === 'Html_Always'}
						/>
					)}
				</PanelRow>
				<PanelRow>
					<div class="bg_panel_btns_wrapp">
						<button class="db_panel_btn_add" onClick={() => AddedSubProduct()}>
							<span class="dashicons dashicons-plus"></span>
						</button>
						<button
							class="db_panel_btn_remove"
							onClick={() => removeSubProduct(subdata.sub_id)}
						>
							<span class="dashicons dashicons-minus"></span>
						</button>
					</div>
				</PanelRow>
			</div>
		</>
	);
};
const ProductSubCategory = (props) => {
	const {
		rule_and_condition,
		setAttributes,
		attributes,
		setRulesCondition,
		list,
		RulesTypes,
		removeform,
		setRemoveform,
		dragstatus,
		defaultreset,
		setdefaultreset,
		setDragstatus,
		removeCrosssign,
		subdata,
	} = props;
	
	const [ProductOption, setProductOption] = useState([]);
	const [option, setoption] = useState();
	const [inputstatus, setinputstatus] = useState(Boolean);
	const [opreatorOption, setopreatorOption] = useState([]);
	const [condition_input_type, setCondition_input_type] = useState(true);

	useEffect(() => {
		if (removeform || dragstatus) {
			selectrules(subdata?.display_rule_types, false);
		}
	}, [rule_and_condition]);

	useEffect(() => {
		if (subdata?.display_rule_types?.length > 0) {
			selectrules(subdata?.display_rule_types, false);
		} else {
			let defaultOption = RulesTypes?.filter((option) => {
				return option?.optionType === attributes?.dataset[0].value;
			});
			selectrules(defaultOption[0].value, false);
		}
		removeCrosssign();
	}, [list?.data_filter.length]);

	useEffect(() => {
		if (subdata?.display_rule_types) {
			const optionTypess = RulesTypes?.find((getopt) => {
				return getopt?.value === subdata?.display_rule_types;
			});
			if (optionTypess) {
				let resetOption = attributes?.dataset?.filter((option) => {
					return option?.value === optionTypess?.optionType;
				});
				if (resetOption.length === 0) {
					subdata.values = "";
					subdata.operators = "";
					let defaultOption = RulesTypes?.filter((option) => {
						return option?.optionType === attributes?.dataset[0]?.value;
					});
					if (defaultOption) {
						return selectrules(defaultOption[0].value, false);
					}
				}
			}
		}
	}, [attributes?.dataset]);

	const getListCondition = async (display, status) => {
		await resetData(status);

		const pro_version = RulesTypes?.filter((pro) => {
			return pro.value === display;
		});
		if (pro_version.length > 0) {
			getDetails(pro_version[0]?.value, status, "version");
		} else {
			getDetails(RulesTypes[0]?.value, status, "pro_version");
		}
	};

	const getDetails = (display, status, versions) => {
		subdata.display_rule_types = display;
		const postss = RulesTypes?.filter((data) => {
			if (data.value === display) {
				return data;
			}
		});

		apiFetch({
			path: `/dynamicblock/v1/display_rule_types?rule_type=${display}`,
		}).then((posts) => {
			// operators
			if (posts) {
				if (posts.condition_input_type) {
					if (
						posts.condition_input_type === "Product_Select" ||
						posts.condition_input_type === "Chosen_Select"
					) {
						setinputstatus(false);
						setCondition_input_type(true);
					} else if (
						posts.condition_input_type === "Price_Select" ||
						posts.condition_input_type === "Text" ||
						posts.condition_input_type === "Store_Order_Count"
					) {
						setinputstatus(true);
					} else if (
						posts.condition_input_type === "Order_Status" ||
						posts.condition_input_type === "Select"
					) {
						setinputstatus(false);
						setCondition_input_type(false);
					} else {
						setCondition_input_type(true);
					}
				}
				if (opreatorOption.length === 0) {
					let operator = posts?.operators;
					for (const [key, value] of Object?.entries(operator)) {
						let rules = {};
						(rules.label = value),
							(rules.value = key),
							opreatorOption.push(rules);
						setopreatorOption(opreatorOption);
					}
				}

				//  values
				let values = posts.values;
				for (const [key, value] of Object?.entries(values)) {
					let rules = {};

					(rules.label = value), (rules.value = key), ProductOption.push(rules);
					setProductOption(ProductOption);
				}

				return applyconditions(status, versions);
			}
		});	
	};

	const AddedSubProduct = () => {
		const newSubRules = {
			sub_id: uuidv4(),
			display_rule_types: "",
			values: "",
			operators: "",
			child_rule_type: 0,
		};
		list?.data_filter?.push(newSubRules);
		setRulesCondition(rule_and_condition);
		setAttributes({
			rule_and_condition: JSON.stringify(rule_and_condition),
		});
	};

	const removeSubProduct = (subdata_id) => {
		const removeval = list?.data_filter?.filter((sub) => {
			if (sub?.sub_id !== subdata_id) {
				return sub;
			}
		});
		if (removeval[0]?.sub_id?.length > 0) {
			while (list?.data_filter?.length) {
				list?.data_filter.pop();
			}
			if (removeval[0]?.sub_id?.length > 0 && list?.data_filter.length === 0) {
				removeval.map((data_remain) => {
					list?.data_filter.push(data_remain);
					setRulesCondition(rule_and_condition);
					return setAttributes({
						rule_and_condition: JSON.stringify(rule_and_condition),
					});
				});
			}
		}
	};

	const applyconditions = (status, versions) => {
		if (defaultreset) {
			setOperator(opreatorOption[0]?.value);
			subdata.values = "";
			setoption([]);
			setdefaultreset(false);
			setRulesCondition(rule_and_condition);
			return setAttributes({
				rule_and_condition: JSON.stringify(rule_and_condition),
			});
		} else if (
			!defaultreset &&
			!dragstatus &&
			removeform &&
			subdata.values.length &&
			subdata.operators.length
		) {
			// when defaultreset  is false and removeform
			const selectremoveform =
				subdata.values?.length > 0 ? JSON.parse(subdata?.values) : [];
			setoption(selectremoveform);
			setRemoveform(false);
		} else if (dragstatus) {
			setoption([]);
			// setopreatorOption([])
			setDragstatus(false);
			const val =
				subdata?.values.length === 0 ? "" : JSON.parse(subdata?.values);
			return setoption(val);
		} else if (status) {
			subdata.values = "";
			subdata.operators = opreatorOption[0]?.value;
			setOperator(opreatorOption[0]?.value);
		} else if (versions === "pro_version") {
			subdata.operators = "";
			subdata.values = "";
			setoption([]);
			setRulesCondition(rule_and_condition);
			return setAttributes({
				rule_and_condition: JSON.stringify(rule_and_condition),
			});
		} else {
			const selectedoption =
				subdata.values?.length > 0 ? JSON.parse(subdata?.values) : [];
			setoption(selectedoption);
		}
	};

	const resetData = async (status) => {
		if (status) {
			setoption([]);
		}
		while (opreatorOption?.length) {
			opreatorOption.pop();
		}

		while (ProductOption?.length) {
			ProductOption.pop();
		}
		setopreatorOption([]);
		setRulesCondition(rule_and_condition);
		setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
	};

	const selectrules = (option, status) => {
		subdata.display_rule_types = option;
		getListCondition(option, status);
		setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
	};

	const setOperator = (option) => {
		subdata.operators = option;
		setRulesCondition(rule_and_condition);
		setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
	};

	const setproducts = (option, type) => {
		subdata.operators =
			subdata.operators.length > 0
				? subdata.operators
				: opreatorOption[0].value;
		if ("option" === type) {
			if (condition_input_type) {
				subdata.values = JSON.stringify(option);
			} else {
				subdata.values = JSON.stringify([option]);
			}
			setoption(option);
			setRulesCondition(rule_and_condition);
			setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
		} else if (inputstatus) {
			const { type, value } = option.target;
			let objectval = {
				label: type,
				value: value,
			};
			subdata.values = JSON.stringify([objectval]);
			setoption(objectval);
			setRulesCondition(rule_and_condition);
			setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
		}
	};
	return (
		<>
			<div id={subdata.id} className="selection-menu bg_panel_inputs_wrapp">
				<PanelRow>
					<select
						value={subdata?.display_rule_types}
						onChange={(e) => selectrules(e.target.value, true)}
					>
						{attributes?.dataset?.map((optgrp) => {
							return (
								<>
									<optgroup label={optgrp?.label}>
										<option value="" disabled selected hidden>
											Please select {RulesTypes[0]?.label}
										</option>
										{RulesTypes?.map((opt_type) => {
											if (opt_type.optionType === optgrp?.label) {
												return (
													<option
														value={opt_type?.value}
														style={{ color: opt_type?.disabled ? "red" : "" }}
														disabled={opt_type?.disabled}
													>
														{opt_type?.label}
													</option>
												);
											}
										})}
									</optgroup>
								</>
							);
						})}
					</select>
				</PanelRow>
				<PanelRow>
					<SelectControl
						value={subdata?.operators?.length > 0 ? subdata.operators : ""}
						options={opreatorOption}
						placeholder={__("Select some users:")}
						onChange={(newval) => setOperator(newval)}
					/>
				</PanelRow>
				<PanelRow>
					{!inputstatus ? (
						<Select
							value={JSON.stringify(option)?.length > 2 ? option : []}
							options={ProductOption}
							isMulti={condition_input_type}
							onChange={(e) => setproducts(e, "option")}
						/>
					) : (
						<input
							value={option[0]?.value}
							onChange={(e) => setproducts(e, "input")}
						/>
					)}
				</PanelRow>
				<PanelRow>
					<div class="bg_panel_btns_wrapp">
						<button class="db_panel_btn_add" onClick={() => AddedSubProduct()}>
							<span class="dashicons dashicons-plus"></span>
						</button>
						<button
							class="db_panel_btn_remove"
							onClick={() => removeSubProduct(subdata.sub_id)}
						>
							<span class="dashicons dashicons-minus"></span>
						</button>
					</div>
				</PanelRow>
			</div>
		</>
	);
};


const StyleComponent = (props) => {	
	const { attributes, setAttributes } = props;
	const getAttr = props.props.attributes;  

	return (
		<PanelBody className="bg_style_tab_content bg_block_tab_content_wrap" title="Content Options" initialOpen={true}>
			<PanelRow>
				<ToggleControl 
					className="gb-toggle-control"
					label={__("Show Product Excerpt")}
					help={__("display short description")}
					checked={ getAttr.excerptToggle }
      				onChange={(val) => setAttributes({ excerptToggle: val })}
					
				/>
			</PanelRow>
			<PanelRow>
				<ToggleControl
					className="gb-toggle-control"
					label={__("Enable Carousel")}
					checked={getAttr.carouselToggle}
					help={__("show in grid with carousel")}
					onChange={(val) => setAttributes({ carouselToggle: val })}
				/>
			</PanelRow>
			<PanelRow>
				<ToggleControl
					className="gb-toggle-control"
					label={__("Display Add to Cart Button")}
					checked={getAttr.addToCartBtnToggle}
					help={__("display add to cart")}
					onChange={(val) => setAttributes({ addToCartBtnToggle: val })}
				/>
			</PanelRow>
			<PanelRow>
				<ToggleControl
					className="gb-toggle-control"
					label={__("AutoPlay")}
					checked={getAttr.autoplayToggle}
					help={__("enable autoplay for carousel")}
					onChange={(val) => setAttributes({ autoplayToggle: val })}
				/>
			</PanelRow>
		</PanelBody>
	)
}

const AdvancedComponent = (props) => {
	const { attributes, setAttributes } = props;
	const getAttr = props.props.attributes; 
	
	return (
		<div>
			<PanelBody  className="bg_advanced_tab_content bg_block_tab_content_wrap" title={__('Style')} initialOpen={true}>
				<PanelRow>
						<TextControl
							label={__("Custom Css Class")}
							placeholder={__("insert here custom class")}
							value={getAttr.gbcustomCssClass}
							onChange={(val) => setAttributes({ gbcustomCssClass: val })}
						/>
				</PanelRow>
				<PanelRow>
					<div className="gb_code_mirror_cmp">
						<label>Custom Css</label>
						<CodeMirror
							placeholder={__("#id {\n   display: block;\n}")}
							value={getAttr.gbcustomCss}
							extensions={[css()]}
							label={__("Custom Css Class")}
							onChange={(val) => setAttributes({ gbcustomCss: val })}
						/>
					</div>
				</PanelRow>
				<PanelRow>
					<div className="gb_code_mirror_cmp">
						<label>Custom JS</label>
						<CodeMirror
							placeholder={__("console.log('success...');")}
							value={getAttr.gbcustomJs}
							extensions={[basicSetup, javascript()]}
							onChange={(val) => setAttributes({ gbcustomJs: val })}
						/>
					</div>
				</PanelRow>
			</PanelBody>
			<PanelBody title={__('UTM Params')} initialOpen={false}>
				<PanelRow>
						<TextareaControl
							label={__("UTM Source")}
							type="textarea"
							placeholder={__("UTM Source")}
							value={getAttr.gbutmSource}
							onChange={(val) => setAttributes({ gbutmSource: val })}
						/>
				</PanelRow>
				<PanelRow>
						<TextareaControl
							label={__("UTM Medium")}
							type="textarea"
							placeholder={__("UTM Medium")}
							value={getAttr.gbutmMedium}
							onChange={(val) => setAttributes({ gbutmMedium: val })}
						/>
				</PanelRow>
				<PanelRow>
					<TextareaControl
						label={__("UTM Campaign")}
						type="textarea"
						placeholder={__("UTM Campaign")}
						value={getAttr.gbutmCampaign}
						onChange={(val) => setAttributes({ gbutmCampaign: val })}
					/>
				</PanelRow>
			</PanelBody>
		</div>
	)
}